import React from 'react';
import { WttpQuestionnaireQuestion } from 'src/graphql/generated/graphql';
import { Table } from '@otp/ui';
import { t } from 'i18next';
import { getTableConfig } from './table-config';

interface WttpQuestionsListFormProps {
  onChange: (selectedQuestions: WttpQuestionnaireQuestion[]) => void;
  entities: WttpQuestionnaireQuestion[];
  entityLoading: boolean;
}

export const WttpQuestionnaireQuestionsOrderForm: React.FC<
  WttpQuestionsListFormProps
> = ({ onChange, entities, entityLoading }) => {
  const wttpQuestions = entities || [];
  const tableConfig = getTableConfig(wttpQuestions || [], { t });

  const onRowsSorted:
    | ((data: (object | string[] | number[])[]) => void)
    | undefined = (data) => {
    const newRows = data.map((row, index) => {
      return {
        ...row,
        order: index + 1,
      } as WttpQuestionnaireQuestion;
    });
    onChange(newRows);
  };

  const setRowProps = (
    row: any[],
    dataIndex: number,
    rowIndex: number,
  ): object => {
    if (wttpQuestions && !wttpQuestions[rowIndex].parentId) {
      return {};
    }
    return {
      style: {
        backgroundColor: 'var(--mui-palette-secondary-200)',
      },
    };
  };

  return (
    <div className="bg-white flex-1 flex flex-col">
      <Table
        options={{
          sort: true,
          setRowProps: setRowProps,
        }}
        onRowsSorted={onRowsSorted}
        data={wttpQuestions}
        columns={tableConfig}
        isRowsSortable={true}
        rowVariant="outlined"
        loading={entityLoading}
      />
    </div>
  );
};
